import { render } from "./FormatDate.vue?vue&type=template&id=b10f32e4&scoped=true&ts=true"
import script from "./FormatDate.vue?vue&type=script&lang=ts"
export * from "./FormatDate.vue?vue&type=script&lang=ts"

import "./FormatDate.vue?vue&type=style&index=0&id=b10f32e4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b10f32e4"]])

export default __exports__